import React, { Component } from "react";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import MobileNotification from "../common/MobileNotification";
import Button from "../common/Button";
import Schedule from "../common/Schedule";
import { DropdownButton, MenuItem } from "react-bootstrap";
import MessagesView from "./MessagesView";
import QuotesView from "./QuotesView";
import DriverDetails from "./DriverDetails";
import PageLoader from "../common/PageLoader";
import JobDetails from "../JobSliderView/JobDetails";
import CustomScroll from "react-custom-scroll";
import { queryStringtoArray } from "../../helpers/index";
import { cloneDeep } from "lodash";
import MobileHeaderSearch from "../common/MobileHeaderSearch";

export default class JobDetailsView extends Component {
  constructor(props, context) {
    super(props, context);
    this.toggleNotification = this.toggleNotification.bind(this);
    const routeParams = this.props.routeParams;
    this.state = {
      searchMobile: false,
      notificationVisible: false,
      showSidebar: false,
      isSliderLoaded: false,
      jobId: routeParams.job_id,
      messageVisible: false,
      chassisNumber: ""
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.windowWidth = this.windowWidth.bind(this);
  }

  componentWillMount() {
    const windowWidth = window.innerWidth;
    if (windowWidth >= 1100) {
      this.setState({
        currentTab:
          queryStringtoArray("current_tab") &&
          queryStringtoArray("current_tab") == "messages"
            ? "messages"
            : "quotes"
      });
    }
    if (this.state.jobId) {
      if (this.props.jobRequestReducer.jobList[this.state.jobId]) {
        if (
          this.props.jobRequestReducer.jobList[this.state.jobId] &&
          this.props.jobRequestReducer.jobList[this.state.jobId]
            .requeststatus &&
          this.props.jobRequestReducer.jobList[this.state.jobId].requeststatus
            .name &&
          this.props.jobRequestReducer.jobList[this.state.jobId].requeststatus
            .name == "Waiting" &&
          !this.props.jobRequestReducer.jobList[this.state.jobId].alreadySeen
        ) {
          this.props.actions.updateNewCount(this.state.jobId);
        }
/*        if(this.props.jobRequestReducer.jobList[this.state.jobId].jobStatus=== "completed" || this.props.jobRequestReducer.jobList[this.state.jobId].jobStatus === "in progress"){
          this.props.actions.getPostedJobById(this.state.jobId);
        } else {
          this.setState({ isSliderLoaded: true });
        }*/
        this.setState({ isSliderLoaded: true });

      } else {
        this.props.actions.getPostedJobById(this.state.jobId);
      }
    } else {
      this.props.router.push("404");
    }

    window &&
      window.socket &&
      window.socket.on("my-location", function(data) {
        console.log("my-location  Accepted", data);
        alert("data");
      });
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    const windowWidth = window.innerWidth;
    if (windowWidth <= 1100) {
      this.setState({ currentTab: "jobDetails" });
    }
  }

  componentWillReceiveProps(nextProps) {
    const currentRouteParams = this.props.routeParams;
    const nextRouteParams = nextProps.routeParams;
    if (
      currentRouteParams.job_id &&
      nextRouteParams.job_id &&
      currentRouteParams.job_id != nextRouteParams.job_id
    ) {
      if (!nextProps.jobRequestReducer.jobList[nextRouteParams.job_id]) {
        this.props.actions.getPostedJobById(nextRouteParams.job_id);
        this.setState({
          isSliderLoaded: false,
          jobId: nextRouteParams.job_id,
          currentTab: "quotes"
        });
      } else {
        this.setState({
          isSliderLoaded: true,
          jobId: nextRouteParams.job_id,
          currentTab: "quotes"
        });
      }
    }
    if (
      nextProps.jobRequestReducer &&
      nextProps.jobRequestReducer.isSliderLoaded &&
      !this.state.isSliderLoaded
    ) {
      this.setState({ isSliderLoaded: true });
    }
    if (
      nextProps.jobRequestReducer.jobList[this.state.jobId] &&
      nextProps.jobRequestReducer.jobList[this.state.jobId].requeststatus &&
      nextProps.jobRequestReducer.jobList[this.state.jobId].requeststatus
        .name &&
      nextProps.jobRequestReducer.jobList[this.state.jobId].requeststatus
        .name == "Waiting" &&
      !nextProps.jobRequestReducer.jobList[this.state.jobId].alreadySeen
    ) {
      nextProps.actions.updateNewCount(this.state.jobId);
    }
    if (nextProps.commonReducer && nextProps.commonReducer.showMessageTab) {
      this.setState({ currentTab: "messages" });
      this.props.actions.toggleMessageTab(false);
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    const windowWidth = window.innerWidth;
    if (windowWidth >= 1100) {
      this.state.currentTab == "jobDetails"
        ? this.setState({ currentTab: "quotes" })
        : "";
      // this.setState({currentTab:'jobDetails'});
    }
  }

  toggleNotification(isVisible) {
    this.setState({ notificationVisible: isVisible });
  }

  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }
  windowWidth() {
    let docElemProp = window.document.documentElement.clientWidth,
      body = window.document.body;
    return (
      (window.document.compatMode === "CSS1Compat" && docElemProp) ||
      (body && body.clientWidth) ||
      docElemProp
    );
  }

  onChangeChassis(value) {
    console.log('What is chassis ', value);
    this.setState({
      chassisNumber: value
    });
  }
  render() {
    const { jobRequestReducer, actions, router, commonReducer } = this.props;
    const windowWidth = this.windowWidth();
    const requestDetails = jobRequestReducer.jobList[this.state.jobId];
    const unableToFetchPostedJobById =
      jobRequestReducer.unableToFetchPostedJobById;
    let currentTab = this.state.currentTab;
    if (
      currentTab == "messages" &&
      requestDetails &&
      requestDetails.jobStatus &&
      !(
        (requestDetails.jobStatus.toLowerCase() != "waiting") &&
        requestDetails.serviceId != 4
      )
    ) {
      currentTab = "quotes";
    }
    return (
      <div>
        {/*Header*/}
        <Header
          searchMobile={this.state.searchMobile}
          hideOption={() => this.setState({ searchMobile: true })}
          notificationCount={2}
          commonReducer={this.props.commonReducer}
          actions={this.props.actions}
          profileName="Derrick Frank"
          notificationCallBack={this.toggleNotification}
          authReducer={this.props.authReducer}
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={this.props.router}
        />
        <MobileNotification
          isVisible={this.state.notificationVisible}
          backBtnCallBack={this.toggleNotification}
        />
        <div className="main-wrapper">
          {/*Sidebar*/}
          <Sidebar
            showSidebar={this.state.showSidebar}
            router={this.props.router}
            actions={this.props.actions}
            commonReducer={this.props.commonReducer}
            authReducer={this.props.authReducer}
          />
          <div className="container-fluid main-container">
            <div className="col-md-9 mpad0 padr30">
              {this.state.isSliderLoaded && requestDetails ? (
                <div className="jd-content-holder">
                  <div
                    className={`overview-heading overview-heading-border  ${requestDetails.jobStatus
                      .replace(/\s+/, "")
                      .toLowerCase()} ${
                      requestDetails.isurgentrequest
                    }-emergency`}
                  >
                    <h5>Request ID: {requestDetails.requestid}</h5>
                    <span>{requestDetails.createdAt}</span>
                  </div>
                  <div className="content-view row jobDetails-content-wrapper">
                    {windowWidth >= 1100 ? (
                      <div className="jobDetails-wrapper-deskView">
                        <div className="col-md-6 pad0 jobSlider-left">
                          <div className="jobDetails-details-view">
                            <CustomScroll
                              heightRelativeToParent="calc(100%)"
                              allowOuterScroll={true}
                            >
                              {<JobDetails
                                requestDetails={requestDetails}
                                chassisNumberChange= {this.onChangeChassis.bind(this)}
                                noeditchassis={false}
                              />}
                            </CustomScroll>
                          </div>
                        </div>
                        <div className="col-md-6 pad0">
                          <div className="jd-quotesMessages-wrapper">
                            <div className="quotesMessages-header">
                              <ul>
                                <li
                                  onClick={e => {
                                    e.preventDefault();
                                    if (currentTab != "quotes") {
                                      this.setState({ currentTab: "quotes" });
                                    }
                                  }}
                                  className={
                                    currentTab == "quotes" ? "active" : ""
                                  }
                                >
                                  Quotes
                                </li>
                                {(requestDetails.jobStatus.toLowerCase() !=
                                  "waiting") &&
                                  requestDetails.serviceId != 4 && (
                                    <li
                                      onClick={e => {
                                        e.preventDefault();
                                        if (currentTab != "messages") {
                                          this.setState({
                                            currentTab: "messages"
                                          });
                                        }
                                      }}
                                      className={
                                        currentTab == "messages" ? "active" : ""
                                      }
                                    >
                                      Message
                                    </li>
                                  )}
                                {requestDetails.serviceId == 4 &&
                                  (requestDetails.jobStatus.toLowerCase() ==
                                    "confirmed" ||
                                    requestDetails.jobStatus.toLowerCase() ==
                                      "completed" ||
                                    requestDetails.jobStatus ==
                                      "in progress") && (
                                    <li
                                      onClick={e => {
                                        e.preventDefault();
                                        if (currentTab != "driverInfo") {
                                          this.setState({
                                            currentTab: "driverInfo"
                                          });
                                        }
                                      }}
                                      className={
                                        currentTab == "driverInfo"
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      Driver Details
                                    </li>
                                  )}
                              </ul>
                            </div>
                            {currentTab == "messages" ? (
                              <MessagesView
                                {...this.props}
                                requestDetails={requestDetails}
                              />
                            ) : currentTab == "driverInfo" ? (
                              <DriverDetails
                                {...this.props}
                                requestDetails={requestDetails}
                              />
                            ) : (
                              <QuotesView
                                actions={actions}
                                requestDetails={requestDetails}
                                commonReducer={commonReducer}
                                chassisNumber={this.state.chassisNumber}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="jobDetails-wrapper-mobileView">
                        <ul className="jobdDetails-wrapper-tab-header">
                          <li
                            onClick={e => {
                              e.preventDefault();
                              if (currentTab != "jobDetails") {
                                this.setState({ currentTab: "jobDetails" });
                              }
                            }}
                            className={
                              currentTab == "jobDetails" ? "active" : ""
                            }
                          >
                            Job Details
                          </li>
                          <li
                            onClick={e => {
                              e.preventDefault();
                              if (currentTab != "quotes") {
                                this.setState({ currentTab: "quotes" });
                              }
                            }}
                            className={currentTab == "quotes" ? "active" : ""}
                          >
                            Quotes
                          </li>
                          {requestDetails.jobStatus &&
                            (requestDetails.jobStatus.toLowerCase() ==
                              "applied" ||
                              requestDetails.jobStatus.toLowerCase() ==
                                "confirmed" ||
                              requestDetails.jobStatus.toLowerCase() ==
                                "inprogress" ||
                              requestDetails.jobStatus.toLowerCase() ==
                                "in progress" || requestDetails.jobStatus.toLowerCase() ==
                                "completed") &&
                            requestDetails.serviceId != 4 && (
                              <li
                                onClick={e => {
                                  e.preventDefault();
                                  if (currentTab != "messages") {
                                    this.setState({ currentTab: "messages" });
                                  }
                                }}
                                className={
                                  currentTab == "messages" ? "active" : ""
                                }
                              >
                                Message
                              </li>
                            )}
                          {requestDetails.serviceId == 4 &&
                            (requestDetails.jobStatus == "confirmed" ||
                              requestDetails.jobStatus == "completed" ||
                              requestDetails.jobStatus == "in progress") && (
                              <li
                                onClick={e => {
                                  e.preventDefault();
                                  if (currentTab != "driverInfo") {
                                    this.setState({ currentTab: "driverInfo" });
                                  }
                                }}
                                className={
                                  currentTab == "driverInfo" ? "active" : ""
                                }
                              >
                                Driver Details
                              </li>
                            )}
                        </ul>
                        <div className="jD_mobile-content-wrapper">
                          <div className="jobDetails-details-view">
                            {currentTab == "jobDetails" && (
                              <CustomScroll
                                heightRelativeToParent="calc(100%)"
                                allowOuterScroll={true}
                              >
                                {<JobDetails
                                  requestDetails={requestDetails}
                                  chassisNumberChange= {this.onChangeChassis.bind(this)}
                                  noeditchassis={false}
                                />}
                              </CustomScroll>
                            )}
                            {currentTab == "messages" &&
                            currentTab != "jobDetails" ? (
                              <MessagesView
                                {...this.props}
                                requestDetails={requestDetails}
                              />
                            ) : currentTab == "driverInfo" ? (
                              <DriverDetails
                                {...this.props}
                                requestDetails={requestDetails}
                              />
                            ) : (
                              <QuotesView
                                actions={actions}
                                requestDetails={requestDetails}
                                commonReducer={commonReducer}
                                chassisNumber={this.state.chassisNumber}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : this.state.isSliderLoaded && unableToFetchPostedJobById ? (
                <div
                  style={{
                    height: "400px",
                    textAlign: "center",
                    paddingTop: "40px"
                  }}
                >
                  <div className="sliderHeader">
                    <div className="slider-btn-right">
                      <span
                        className="jobSlider-close"
                        onClick={this.props.modalCloseCallBack}
                      >
                        <i className="mdi mdi-close" />
                      </span>
                    </div>
                  </div>
                  <h3>
                    Unable to fetch data{" "}
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={e => {
                        e.preventDefault;
                        this.props.actions.getPostedJobById(this.state.jobId);
                      }}
                    >
                      Try Again
                    </a>
                  </h3>
                </div>
              ) : (
                <div
                  style={{
                    height: "400px",
                    textAlign: "center",
                    paddingTop: "40px"
                  }}
                >
                  <div className="sliderHeader">
                    <div className="slider-btn-right">
                      <span
                        className="jobSlider-close"
                        onClick={this.props.modalCloseCallBack}
                      >
                        <i className="mdi mdi-close" />
                      </span>
                    </div>
                  </div>
                  <PageLoader />
                </div>
              )}
            </div>
            <div className="col-md-3 mpad0 padLeft0">
              <Schedule
                commonReducer={this.props.commonReducer}
                router={this.props.router}
              />
            </div>
          </div>
        </div>
        {this.state.searchMobile && (
          <div>
            <MobileHeaderSearch
              mobile={true}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              mobSearchClick={() => this.setState({ searchMobile: false })}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JobDetailsView/JobDetailsView.jsx